import { ArrowUpRight, Target, Tv, Sparkles, MousePointerClick, Network, TrendingUp, Users, MapPin } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const SERVICES = [
  { icon: Target, title: "Programmatic Ads", body: "Precision-targeted programmatic campaigns across brand-safe, top worldwide inventories — maximizing ROI on every impression.", span: "md:col-span-7" },
  { icon: Tv, title: "CTV & OTT Advertising", body: "Branding on CTV & OTT platforms at the best CPMs, with immersive formats and CTRs that outperform benchmarks.", span: "md:col-span-5" },
  { icon: Sparkles, title: "Influencer Marketing", body: "Authentic voices that amplify your story and connect with audiences naturally.", span: "md:col-span-4" },
  { icon: MousePointerClick, title: "Paid Media Solutions", body: "From search to social — campaigns engineered to grab attention, drive traffic, and convert.", span: "md:col-span-8" },
  { icon: Network, title: "Affiliate Marketing", body: "Expand your reach with trusted affiliates who promote your products and grow revenue.", span: "md:col-span-6" },
  { icon: TrendingUp, title: "Performance Marketing", body: "Obsessed with the outcomes that matter — leads, sales, and measurable growth, optimized in real time.", span: "md:col-span-6" },
  { icon: Users, title: "Lead Generation", body: "Fill your sales pipeline with high-quality leads through targeted campaigns that convert.", span: "md:col-span-5" },
  { icon: MapPin, title: "Offline Marketing", body: "Experiential campaigns, events, and traditional media that connect beyond screens.", span: "md:col-span-7" },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="py-28 md:py-40 border-t border-white/10">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 md:mb-24">
        <div>
          <Reveal>
            <Overline>What We Do</Overline>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight" data-testid="services-heading">
              Services That<br /><span className="italic text-[#8B5CF6]">Actually Deliver</span>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <p className="max-w-sm text-base text-[#A0A0AB] font-light leading-relaxed">
            Brand-safe, top worldwide inventories. Integrated with leading DSP
            & SSP partners in India and across the globe — so your story reaches
            the right people, at the right time, at the right price.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-px bg-white/10 border border-white/10">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={(i % 3) * 0.08} className={s.span} y={24}>
            <div
              data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="group relative h-full bg-[#09090A] p-8 md:p-12 overflow-hidden transition-colors duration-500 hover:bg-[#121214]"
            >
              <div
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none"
                style={{ background: "radial-gradient(circle at 85% 15%, rgba(139,92,246,0.12), transparent 60%)" }}
                aria-hidden="true"
              />
              <div className="relative flex items-start justify-between">
                <span className="font-accent text-xs tracking-[0.3em] text-[#52525B]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <ArrowUpRight className="w-5 h-5 text-[#52525B] transition-all duration-300 group-hover:text-[#8B5CF6] group-hover:translate-x-1 group-hover:-translate-y-1" />
              </div>
              <s.icon className="relative mt-10 w-8 h-8 text-[#8B5CF6]" strokeWidth={1.25} />
              <h3 className="relative mt-6 font-display text-2xl md:text-3xl tracking-tight">{s.title}</h3>
              <p className="relative mt-4 text-sm md:text-base text-[#A0A0AB] font-light leading-relaxed max-w-md">{s.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
